import {useQuery} from "@tanstack/react-query";
import {listMyFavoriteGamesService} from "../../services/games/miniGames/favoriteGames.service";

const useListFavoriteGames = () => {
  const {data, isSuccess, isLoading, isError, error} = useQuery({
    queryKey: ["listFavoriteGames"],
    queryFn: listMyFavoriteGamesService,
    staleTime: 300,
  });

  return {listFavGames: data, isSuccess, isError, error, isLoading};
};

export default useListFavoriteGames;
